import { useErrorHandler } from './apiErrorHandlers';

const DEFAULT_OPTS = {
  cabeceras: true, csrf: true, token: null, signature: null, errorHandlerCallback: null
};

export default class {
  constructor(axiosInstance, options = {}) {
    this.axiosInstance = axiosInstance;
    this.options = { ...DEFAULT_OPTS, ...options };
  }

  load() {
    if (this.options.cabeceras) {
      this.#cargarCabeceras();
    }
    if (this.options.csrf) {
      this.#cargarCSRF();
    }
    if (this.options.token) {
      this.#setAuthToken();
    }
    if (this.options.errorHandlerCallback) {
      this.#setErrorHandler();
    }
  }

  // Si está arrancado en el puerto de desarrollo de Vite, ponemos la URL base apuntando a
  // la de desarrollo de Rails
  activateDevelopment(window) {
    const url = new URL(window.location.href);
    if (url.port === '3001' || url.port === '5173') {
      this.axiosInstance.defaults.baseURL = 'http://127.0.0.1:3000/';
    }
  }

  /* eslint class-methods-use-this: "off", dot-notation: "off" */
  #cargarCabeceras() {
    // Esto indica al servidor que es una petición ajax
    this.axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    // Desactivamos caché de las apis
    this.axiosInstance.defaults.headers.common['Cache-Control'] = 'no-cache';
    this.axiosInstance.defaults.headers.common['Pragma'] = 'no-cache';
    this.axiosInstance.defaults.headers.common['Expires'] = '0';
  }

  // Ojo que ya tiene que estar cargado el DOM con los META
  #cargarCSRF() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta) {
      this.axiosInstance.defaults.headers.common['X-CSRF-Token'] = meta.getAttribute('content');
    }
  }

  #setAuthToken() {
    // Configuramos axios con el token para pedir los datos
    this.axiosInstance.interceptors.request.use((config) => {
      config.headers.Authorization = `Token token=${this.options.token}`;
      config.headers.signature = this.options.signature;
      return config;
    });
  }

  #setErrorHandler() {
    const axiosHandler = useErrorHandler(this.options.errorHandlerCallback);
    this.axiosInstance.interceptors.response.use((response) => response, axiosHandler);
  }
}